<template>
  <div id="app" class="container text-center">
    <h1 class="display-4 my-4">POC Headleass CDS Extended API</h1>
    <div v-if="!showContent" class="d-flex justify-content-center gap-2">
      <button class="btn-a custom-primary" @click="startProcess">Comenzar Registro Tradicional</button>
      <button class="btn-a custom-facebook" @click="facebookLogin">Iniciar con Facebook</button>
      <button class="btn-a custom-google" @click="googleLogin">Iniciar con Google</button>
    </div>
    <router-view v-if="showContent" @reset="showContent = false"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showContent: false,
    };
  },
  methods: {
    startProcess() {
      this.showContent = true;
      this.$router.push('/email');
    },
    facebookLogin() {
      this.showContent = true; // Activa el contenido para mostrar router-view
      this.$router.push('/facebook-auth'); // Redirige a la autenticación de Facebook
    },
    googleLogin() {
      this.showContent = true;
      this.$router.push('/google-auth');
    },
  },
};
</script>

<style>
#app {
  font-family: 'Roboto', sans-serif;
}

h1 {
  color: #343a40;
}

.btn-a {
  font-weight: bold;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.custom-primary {
  background-color: #d1661e;
  color: white;
}

.custom-primary:hover {
  background-color: #4f8524;
}

.custom-facebook {
  background-color: #3b5998;
  color: white;
}

.custom-facebook:hover {
  background-color: #2d4373;
}

.custom-google {
  background-color: #4285F4;
  color: white;
}

.custom-google:hover {
  background-color: #357AE8;
}
</style>